import { UnilevelLegsProps, UnilevelLegsEditorProps } from './UnilevelLegs.types';

/**
 * UnilevelLegs 컴포넌트 props 어댑터
 * 다양한 형식의 props를 표준 UnilevelLegsProps로 변환
 */
export const adaptUnilevelLegsProps = (props: any): UnilevelLegsProps => {
  // 기본값 설정
  const defaultProps: UnilevelLegsProps = {
    id: '',
    style: {},
    className: 'unilevel-legs-component',
    content: {},
    componentProps: {
      title: '추천 레그',
      debugMode: false,
      nodeTitleStyle: {},
      shipperTitleStyle: {},
      lineColor: '#3f51b5'
    },
    pathVariables: {}
  };

  // props가 없으면 기본값 반환
  if (!props) {
    return defaultProps;
  }

  // EditorJS 형식인지 확인
  if (props.data && props.type === 'unilevelLegs') {
    return {
      ...defaultProps,
      id: props.id || defaultProps.id,
      style: props.style || defaultProps.style,
      className: props.className || defaultProps.className,
      content: props.data.content || defaultProps.content,
      componentProps: {
        ...defaultProps.componentProps,
        ...(props.data.componentProps || {})
      },
      pathVariables: props.data.pathVariables || defaultProps.pathVariables
    };
  }

  // 일반적인 React props 형식
  return {
    ...defaultProps,
    ...props,
    componentProps: {
      ...defaultProps.componentProps,
      ...(props.componentProps || {})
    }
  };
};

/**
 * 에디터용 데이터 형식 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptUnilevelLegsEditorProps(originalProps: any): UnilevelLegsEditorProps {
  // 기본 props 변환 사용
  const adaptedProps = adaptUnilevelLegsProps(originalProps);
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {})
  };
}